import { BookingData, BookingState, ServiceUpgradeState } from '@markant-platform/cartridge/model';

export const isBookingActive = (bookingState: BookingState): boolean => {
  return bookingState === BookingState.BOOKED;
};

export const hasUpgradeRequestInProgress = (upgradeState: ServiceUpgradeState | null): boolean => {
  return !!upgradeState && ['UPGRADE_REQUEST_OPEN', 'UPGRADE_REQUEST_APPROVED'].includes(upgradeState);
};

export const hasAvailableUpgradeCandidates = (upgradableCartridgeVariantIds: string[]): boolean => {
  return !!upgradableCartridgeVariantIds.length;
};

export const isUpgradeSuggested = (upgradeState: ServiceUpgradeState | null): boolean => {
  return upgradeState === 'UPGRADE_SUGGESTED';
};

export const getDisableSuggestUpgrade = (booking: BookingData): boolean => {
  const { serviceUpgradeState, blocked, bookingState } = booking;

  const hasSuggestedUpgrade = serviceUpgradeState === 'UPGRADE_SUGGESTED';
  const hasUpgradeInProgress = isBookingActive(bookingState) && hasUpgradeRequestInProgress(serviceUpgradeState);

  return hasSuggestedUpgrade || blocked || hasUpgradeInProgress;
};

export function isDisableSuggestUpgrade(data: {
  serviceUpgradeState: ServiceUpgradeState | null;
  blocked: boolean;
  bookingState: BookingState;
}): boolean {
  const { serviceUpgradeState, blocked, bookingState } = data;

  return (
    serviceUpgradeState === 'UPGRADE_SUGGESTED' ||
    blocked ||
    (isBookingActive(bookingState) && hasUpgradeRequestInProgress(serviceUpgradeState))
  );
}

export const getSuggestUpgradeTooltipTranslationKey = (booking: BookingData): string => {
  const { serviceUpgradeState, blocked, bookingState } = booking;
  const hasUpgradeInProgress = isBookingActive(bookingState) && hasUpgradeRequestInProgress(serviceUpgradeState);
  if (serviceUpgradeState === 'UPGRADE_SUGGESTED') {
    return 'cartridge.management.suggestUpgrade.tooltip.upgraded';
  } else if (blocked) {
    return 'cartridge.management.suggestUpgrade.tooltip.blocked';
  } else if (hasUpgradeInProgress) {
    return '';
  } else {
    return 'cartridge.management.suggestUpgrade.tooltip.available';
  }
};
